import { setGetInviteAction } from '../action';
import { getInvite } from '../api/getInvite';

export const setGetInvite = (params, callback) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getInvite(params);
            dispatch(setGetInviteAction({
                data: data.data,
                current: 0,
                total: 0
            }))

            if (callback) {
                callback();
            }
            
          
        } catch(error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}